<div [formGroup]="form">
  <div class="input-panel">
    <div class="input-label">{{ 'forms.profileDetails.grossAnnualIncomeType' | translate }}</div>
    <div class="input-field">
      <mat-select
        [placeholder]="'common.selectPlaceholder' | translate"
        class="form-control"
        formControlName="grossAnnualIncomeType"
      >
        <mat-option *ngFor="let type of grossAnnualIncome" [value]="type.id">
          {{ type.name }}
        </mat-option>
      </mat-select>
    </div>
    <app-validation-error-message
      [inputName]="'forms.profileDetails.grossAnnualIncomeType' | translate"
      [showFormError]="showFormError"
      [control]="form.get('grossAnnualIncomeType')"
    >
    </app-validation-error-message>
  </div>

  <div class="input-panel">
    <div class="input-label">{{ 'forms.profileDetails.transactionPurpose' | translate }}*</div>
    <div class="input-field">
      <mat-select
        [placeholder]="'common.selectPlaceholder' | translate"
        class="form-control"
        formControlName="transactionPurpose"
      >
        <mat-option *ngFor="let type of transactionPurposes" [value]="type.id">
          {{ type.name }}
        </mat-option>
      </mat-select>
    </div>
    <app-validation-error-message
      [inputName]="'forms.profileDetails.transactionPurpose' | translate"
      [showFormError]="showFormError"
      [control]="form.get('transactionPurpose')"
    >
    </app-validation-error-message>
  </div>
</div>
